import { apiV2, errorHandler } from "./index";
import { API_ERROR } from "../constants/ActionTypes";

/**
 * Add a tag to an object (Session, QuickTap, DailyInspiration, etc.)
 * Returns a promise for use with async/await in components
 */
export function addObjectTag(options) {
  return function (dispatch) {
    return apiV2
      .post('/tags', {
        object_id: options.object_id,
        type: options.object_type,
        tag: options.tag,
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

/**
 * Remove a tag from an object (Session, QuickTap, DailyInspiration, etc.)
 * Returns a promise for use with async/await in components
 */
export function removeObjectTag(options) {
  return function (dispatch) {
    return apiV2
      .post('/tags/remove', {
        object_id: options.object_id,
        type: options.object_type,
        tag: options.tag,
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}
